
import { Link, navigate } from 'gatsby'
import React, { FC } from 'react'
import styled from 'styled-components'

export type LegalDocumentHeaderProps = {
    link: string
}

export const LegalDocumentHeader: FC<{ blok: LegalDocumentHeaderProps | any }> = ({ blok }) => {
    return (
        <StyledConatiner >
            {blok.link.url}

            <span>
                {blok.leadingText}
                {' '}
                {/* <Link to={`/${blok.link.story.full_slug}/`}> */}

                <span style={{ textDecoration: 'underline', cursor: 'pointer' }}

                    onClick={() => {
                        navigate(`/${blok.link.story.full_slug}/`)
                    }}
                >


                    {blok.linkText}
                </span>
                {/* </Link> */}
            </span>

        </StyledConatiner>
    )
}


const StyledConatiner = styled.table`
    display: flex;
    
    /* transform: translateX(); */

     font-size: 0.75rem;
     flex-direction: column;
     align-items: center;
     margin-right: 12px;
     margin-left: 12px;
     
     padding: 0.75rem;
`
